import SectionHead from "./SectionHead";
import { usageScenes } from "@/mocks/content";

export default function Usage() {
  return (
    <section id="usage" className="bg-[#fff8f0] py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          eyebrow="04 · 怎么用"
          title="日常到底怎么接得住"
          desc="光看懂还不够，会“用”才能不掉队。下面还原几个真实感满满的聊天场景，照着说就行。"
        />

        <div className="mt-12 grid gap-5 md:grid-cols-2">
          {usageScenes.map((sc) => (
            <article
              key={sc.who}
              className="rounded-3xl bg-white p-6 ring-1 ring-orange-100 transition-transform hover:-translate-y-1"
            >
              <div className="flex items-center justify-between gap-2">
                <h3 className="text-sm font-bold text-stone-800">{sc.who}</h3>
                <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-600">
                  {sc.tag}
                </span>
              </div>
              <div className="mt-4 space-y-2.5">
                {sc.bubbles.map((b, i) => (
                  <div key={i} className="flex">
                    <div
                      className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${
                        i === 0
                          ? "rounded-tl-sm bg-[#f5efe6] text-stone-600"
                          : "ml-auto rounded-tr-sm bg-rose-500 text-white"
                      }`}
                    >
                      {b}
                    </div>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-4 rounded-3xl bg-white p-7 ring-1 ring-orange-100 sm:flex-row sm:items-center">
          <div className="flex items-start gap-4">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-orange-100 text-xl text-orange-600">
              <i className="ri-lightbulb-flash-line" aria-hidden="true" />
            </span>
            <div>
              <h3 className="text-base font-bold text-stone-800">三个加分小贴士</h3>
              <ul className="mt-2 space-y-1 text-sm leading-relaxed text-stone-500">
                <li>· 搭配“蹲一个后续 / 前排围观”，语气更自然。</li>
                <li>· 别用来跟风造谣，先看来源是否可靠、有无实锤。</li>
                <li>· 自己不懂先问“这是什么意思”，懂梗的人很乐意科普。</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}